import FadeInSection from "../../../components/feature/FadeInSection";

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#e8eef8] via-white to-[#dde8f5] overflow-hidden"
    >
      {/* Decorative circles */}
      <div className="absolute top-20 right-0 w-[500px] h-[500px] rounded-full bg-[#0f2559]/5 blur-[80px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-[#3b6fd4]/8 blur-[100px] pointer-events-none" />

      {/* Dot pattern */}
      <div
        className="absolute inset-0 opacity-[0.035]"
        style={{
          backgroundImage: "radial-gradient(#0f2559 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative z-10 flex flex-col items-center text-center px-6 pt-28 pb-16 w-full max-w-4xl mx-auto">
        {/* Badge */}
        <FadeInSection delay={0}>
          <div className="flex items-center gap-2 bg-[#0f2559]/8 border border-[#0f2559]/15 rounded-full px-4 py-2 mb-8">
            <div className="w-2 h-2 rounded-full bg-[#3b6fd4] animate-pulse" />
            <span className="text-xs text-[#0f2559] tracking-wide uppercase font-semibold">
              AI-Powered Digital Agent
            </span>
          </div>
        </FadeInSection>

        {/* Logo character */}
        <FadeInSection delay={100}>
          <div className="w-32 h-32 md:w-44 md:h-44 flex items-center justify-center mb-8">
            <img
              src="https://static.readdy.ai/image/b0dfad47411a5cab4bb37e29cd654d91/ad7ef5d5c8ae0c30ee62e19ca8db67c2.png"
              alt="Agent Ben"
              className="w-full h-full object-contain"
            />
          </div>
        </FadeInSection>

        {/* Headline */}
        <FadeInSection delay={200}>
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#0f2559] leading-tight tracking-tight mb-5">
            Meet{" "}
            <span className="text-[#3b6fd4]">Agent Ben</span>
          </h1>
          <p className="text-base md:text-lg text-slate-500 max-w-xl leading-relaxed mb-10">
            Your intelligent AI-powered digital agent — designed to work smarter, faster, and without the manual grind. Let Ben handle it.
          </p>
        </FadeInSection>

        {/* CTAs */}
        <FadeInSection delay={320}>
          <a
            href="https://zealous-field-05e22520f.6.azurestaticapps.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#0f2559] hover:bg-[#1a3a6e] text-white font-bold px-12 py-5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-lg shadow-lg hover:shadow-xl hover:scale-105 active:scale-100 no-underline"
          >
            Launch Agent Ben
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg" />
            </div>
          </a>
        </FadeInSection>

        {/* Stats */}
        <FadeInSection delay={440}>
          <div className="mt-16 grid grid-cols-3 gap-6 md:gap-16 w-full max-w-lg">
            {[
              { value: "AI", label: "Powered" },
              { value: "24/7", label: "Available" },
              { value: "100%", label: "Automated" },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col items-center gap-1">
                <span className="text-2xl md:text-3xl font-bold text-[#0f2559]">{stat.value}</span>
                <span className="text-xs text-slate-400 tracking-wide uppercase font-medium">{stat.label}</span>
              </div>
            ))}
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
